import React from 'react'
import TableMui from 'src/components/TableMui'
import { Typography } from '@mui/material'
import { RemoveBatchButton } from './BatchesTable.style'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { cloneDeep } from 'lodash'
import { actions } from '../../StockMovementsState'
import { BatchItem } from '../../StockMovementsTypes'

interface BatchesTableProps {
  focusAddressOrBatchInput: () => void
}

export const BatchesTable = ({ focusAddressOrBatchInput }: BatchesTableProps) => {
  const dispatch = useDispatch()
  const batchesList = useSelector((state) => state.stockMovements.batchesList)

  const removeBatchItemByIndex = (index: number) => {
    const batchesListClone = cloneDeep(batchesList)

    batchesListClone.splice(index, 1)
    dispatch(actions.setBatchesList(batchesListClone))
    focusAddressOrBatchInput()
  }

  const resolveBatchAndAddressCell = (batch: BatchItem) => ((<>{batch.batchId}<br />{batch.address}</>))

  const resolveTableRows = batchesList.map((batch, index) => ({
    ...batch,
    batchIdAndAddress: resolveBatchAndAddressCell(batch),
    remove: <RemoveBatchButton size={16} data-testid='remove-batch-button' onClick={() => removeBatchItemByIndex(index)} />,
  }))

  return (
    <TableMui
      columns={[
        { id: 'batchIdAndAddress', label: 'Lote/End.' },
        { id: 'validity', label: 'Validade' },
        { id: 'quantity', label: 'Qtd' },
        { id: 'remove', label: '' },
      ]}
      rows={resolveTableRows}
      tableFooter={(
        <Typography textAlign='center'>{`Qtd. de lotes: ${batchesList.length}`}</Typography>
      )}
      thinLine
      testId='batches-table'
    />
  )
}
